export default {
  searchCampaign: [],
  totalSearchCampaign: 0,
  categoryCampaign: [],
  sahabatCampaign: [],
  totalSahabatCampaign: 0,
  totalCategoryCampaign: 0,
  urgentCampaign: [],
  totalUrgentCampaign: [],
  campaign: [],
  zxCareCampaign: [],
  totalZxCareCampaign: 0,
  totalCampaign: 0,
  defaultCampaign: [],
  popularCampaign: [],
  pm: [],
  savedPm: null,
  totalPm: 0,
  transactionProduct: null,
  transactionPayment: null,
  transactionTypes: null,
  transactionHistory: null,
  transactionAmount: 0
}